import { ViewStream } from "spyne";

export class Page404View extends ViewStream {
  constructor(props = {}) {
    props.id = "page-404";
    props.template = require("./templates/page-404.tmpl.html");
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    return [["CHANNEL_ROUTE_.*EVENT", "disposeViewStream"]];
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    this.addChannel("CHANNEL_ROUTE", true);
  }
}
